/* GDPR */
export const GA_SHOW_GDPR_MODAL = 'GDPRModalShown';
export const GA_GDPR_ACCEPT_ACTION = 'FollowOrganizerGDPRAccept';
export const GA_GDPR_REJECT_ACTION = 'FollowOrganizerGDPRReject';
